import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-697d4526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_TableHead = _resolveComponent("TableHead")!
  const _component_TableBody = _resolveComponent("TableBody")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_card, null, {
    title: _withCtx(() => [
      _createVNode(_component_ui_title, { title: "订单列表" })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TableHead),
        _withDirectives(_createVNode(_component_TableBody, {
          onRefresh: _ctx.refresh,
          data: _ctx.source.list
        }, null, 8, ["onRefresh", "data"]), [
          [_directive_loading, _ctx.source.loading]
        ])
      ]),
      _createVNode(_component_ui_page, {
        modelValue: _ctx.page.page,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page.page) = $event)),
        info: _ctx.pageInfo
      }, null, 8, ["modelValue", "info"])
    ]),
    _: 1
  }))
}